import { Component, OnInit, ViewEncapsulation, inject, signal } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { MessageService } from "primeng/api";
import { ButtonDirective } from "primeng/button";
import { InputText } from "primeng/inputtext";
import { Password } from "primeng/password";
import { Ripple } from "primeng/ripple";
import { SelectButton } from "primeng/selectbutton";
import { Tag } from "primeng/tag";
import { ToggleSwitch } from "primeng/toggleswitch";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";
import { PaymentSettings, PaymentSettingsService } from "../../services/payment-settings.service";

import { TPipe } from "../../i18n/t.pipe";
import { opt } from "../../i18n/i18n";
@Component({
  standalone: true,
  selector: "app-payments-settings",
  templateUrl: "./payments-settings.component.html",
  styleUrl: "./payments-settings.component.less",
  encapsulation: ViewEncapsulation.None,
  imports: [TPipe, FormsModule, ReactiveFormsModule, RouterLink, ButtonDirective, InputText, Password, Ripple, SelectButton, Tag, ToggleSwitch, Toast, TranslatePipe],
})
export class PaymentsSettingsComponent implements OnInit {
  private fb = inject(FormBuilder);
  private service = inject(PaymentSettingsService);
  private messages = inject(MessageService);

  readonly loading = signal(true);
  readonly saving = signal(false);
  readonly testing = signal(false);
  readonly info = signal<PaymentSettings | null>(null);
  readonly error = signal("");

  readonly modes = [
    opt("Sandbox (prove)", "sandbox"),
    opt("Live (pagamenti reali)", "live"),
  ];
  readonly defaults = [
    opt("Paga in hotel", "hotel"),
    opt("PayPal", "paypal"),
  ];

  readonly form = this.fb.group({
    hotel_enabled: [true],
    paypal_enabled: [false],
    default: ["hotel"],
    paypal_client_id: [""],
    paypal_secret: [""],
    paypal_mode: ["sandbox"],
  });

  ngOnInit(): void {
    this.service.get().subscribe({
      next: (s) => {
        this.apply(s);
        this.loading.set(false);
      },
      error: (e) => {
        this.error.set(this.message(e));
        this.loading.set(false);
      },
    });
  }

  private apply(s: PaymentSettings): void {
    this.info.set(s);
    this.form.reset({
      hotel_enabled: s.hotel_enabled,
      paypal_enabled: s.paypal_enabled,
      default: s.default,
      paypal_client_id: s.paypal_client_id,
      paypal_secret: "",
      paypal_mode: s.paypal_mode,
    });
  }

  save(): void {
    this.saving.set(true);
    this.service.save(this.form.getRawValue() as any).subscribe({
      next: (s) => {
        this.apply(s);
        this.saving.set(false);
        this.toast("success", "Impostazioni salvate");
      },
      error: (e) => {
        this.saving.set(false);
        this.toast("error", this.message(e));
      },
    });
  }

  test(): void {
    this.testing.set(true);
    this.service.test().subscribe({
      next: (r) => {
        this.testing.set(false);
        this.toast(r.ok ? "success" : "error", r.ok ? "PayPal ha accettato le credenziali" : "PayPal ha rifiutato le credenziali o non risponde");
      },
      error: (e) => {
        this.testing.set(false);
        this.toast("error", this.message(e));
      },
    });
  }

  private toast(severity: "success" | "error", detail: string): void {
    this.messages.add({ key: "myKey1", severity, summary: severity === "success" ? "Ok" : "Errore", detail });
  }

  private message(e: HttpErrorResponse): string {
    return e?.error?.message || "Operazione non riuscita. Riprova.";
  }
}
